export default __webpack_public_path__ + "static/media/direct-payment-finder-USA.a62e39a9.gif";